<template>
  <div class="register">
    <v-card class="mx-auto m-5" style="max-width:40%">
      <v-card-title
        class="loginmain justify-center text-white"
        style="font-family: 'Nunito', sans-serif;"
      >
<div class="container">
      <v-img class="centered" max-width="20%" src="img/int3.png" style="opacity: 0.9;display: block;
  margin-left: auto;
  margin-right: auto;
  width: 30%;"/>
   <div class="centered" style="margin-left:220px;margin-top:20px">User Verify</div>
</div>
      </v-card-title>
      <v-form class="container" ref="form" v-model="valid" lazy-validation>
        <v-container fluid>
           <v-text-field
             
              label="CustomerType"
              placeholder="LCO"
              required
              color="black"
              disabled
            ></v-text-field>
          <!-- <v-select
            :items="customer"
            color="black"
            required
            label="Select Which Type Of Customer Your "
            v-model="form.customer"
          ></v-select> -->
          <!-- <v-if></v-if> -->
          <!-- <div v-if="form.customer == 'LCO'"> -->
            <div>
            <v-text-field
              v-model="form.ope"
              label="Enter FR Code"
              placeholder="Enter FR Code"
              required
              color="black"
            ></v-text-field>
          </div>
          <!-- <div
            v-if="form.customer == 'STB NO' || form.customer == 'SMC NO'|| form.customer == 'ACCOUNT NO'"
          >
            <v-text-field
              v-model="form.stb"
              label="Enter number"
              :placeholder="[[form.customer]]"
              required
              color="black"
            ></v-text-field>
          </div> -->
          <div>
            <Button
              cssClass="mx-auto m-4 d-block login"
              @click="handleSubmit"
              rounded
              label="Verify"
              color="primary"
            />
            <!-- <b-button
            style="margin-left:200px;color:white;background-color:#59065d;"
            @click="handleSubmit"
            >Verify</b-button>-->
          </div>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { extractError } from "../../utils/error";
import { verify } from "../../services/quickverify";
import Button from "@/components/Elements/Button.vue";

export default {
  data() {
    return {
      form: {
        stb: "",
        ope: "",
        valid:true
      },
      customer: ["LCO"]
    };
  },
  components: {
    Button
  },
  valid: true,
  methods: {
    async handleSubmit() {
      try {
        const { form, ...payload } = this.form;
        console.log(this.form);
        // if (this.form.customer == "LCO") {
          const result = await verify({ ope: this.form.ope });
          const opentityCode = result.response.Opentity.opentityCode;
          console.log(result.response);
          payload[form] = true;
          this.$router.push({
            name: "Quickpayment",
            params: { opentityCode }
          });
        // } else {
        //   const result = await verify({ stb: this.form.stb });
        //   const accountNo = result.response.accountNo;
        //   payload[form] = true;
        //   this.$router.push({
        //     name: "Quickpayment",
        //     params: { accountNo }
        //   });
        // }
      } catch (err) {
        // console.log(err);
        const message = extractError(err);
        this.$showError(message);
        this.loading = false;
      }
    }
  }
};
</script>
